import { render, staticRenderFns } from "./SettingMobile.vue?vue&type=template&id=07207a09&scoped=true&"
import script from "./SettingMobile.vue?vue&type=script&lang=js&"
export * from "./SettingMobile.vue?vue&type=script&lang=js&"
import style0 from "./SettingMobile.vue?vue&type=style&index=0&id=07207a09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07207a09",
  null
  
)

export default component.exports